import { ReactComponent as Roy } from "../../../../assets/img/welcomeAnimation/Gill_roy_merged.svg";
import styled from "styled-components";
import { keyframes } from "styled-components";

function RoyMessage({ active }) {
  const animationFinished = (e) => {
    // console.log("we're in the Roy Message");
    // console.log(e);
  };
  return (
    <>
      <Wrapper>
        <span
          onAnimationEnd={(e) => animationFinished(e)}
          className={`animation-wrapper  ${active ? "active-animation" : ""}`}
        >
          <Roy />
          <div className="bg-circle"></div>
        </span>
      </Wrapper>
    </>
  );
}

const fadeIn = keyframes`
0%{opacity: 0;}
100% {opacity:1;}
`;
const fadeOut = keyframes`
0%{opacity: 1;}
100% {opacity:0;}
`;
const eyeTransition = keyframes`
0%{opacity: 1;}
50%{opacity: 0}
100% {opacity:1;}
`;

const Wrapper = styled.div`
  .active-animation {
    #noun_Speech-Bubble_486576 {
      opacity: 0;
      animation: ${fadeIn} 2s 2s ease-in-out forwards;
    }
    #Hi {
      opacity: 0;
      animation: ${fadeIn} 2s 0.5s ease-in-out forwards, ${fadeOut} 2s 6s ease-in-out forwards;
    }

    #Message {
      opacity: 0;
      animation: ${fadeIn} 2s 0.5s ease-in-out forwards, ${fadeOut} 2s 6s ease-in-out forwards;
    }
    #Oval {
      animation: ${eyeTransition} 2s 4s ease-in-out forwards;
    }
    #Oval2 {
      animation: ${eyeTransition} 2s 4s ease-in-out forwards;
    }
  }
  .animation-wrapper {
    position: relative;
    .bg-circle {
      position: absolute;
      height: 215px;
      top: -69px;
      border-radius: 50%;
      z-index: -1;
      left: -16px;
      width: 226px;
      background-color: #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 150px;
        height: 150px;
        top: -58px;
        left: -28px;
      }
    }

    #royMerged {
      margin-top: -38px;
      margin-right: -48px;
      position: relative;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-right: -500x;
        max-width: 140px;
        margin-top: -40px;
      }
    }
    #noun_Speech-Bubble_486576 {
      opacity: 0;
    }
    #Hi {
      opacity: 0;
    }

    #Message {
      opacity: 0;
    }
  }
`;

export default RoyMessage;
